<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="CUSTOMER"
        :filter="filter"
        placeholder="Search Name, Telephone, Email"
        @search="handleSearch"
        @export="getFilterExport"
        @downloadTemplate="downLoadTemplate"
        @sidebar="sidebarFilter"
        extendInput
      >
        <template v-slot:extend-input>
          <b-form-input
            type="text"
            id="header-search-bar"
            class="search-bar"
            @keyup.enter="handleSearch()"
            placeholder="Search Member ID."
            v-model="filter.search_member_id"
          >
          </b-form-input>
          <b-input-group-append is-text class="mr-2">
            <b-iconstack font-scale="2" type="submit" @click="handleSearch()">
              <b-icon stacked icon="search" scale="0.5" variant="grey"></b-icon>
            </b-iconstack> </b-input-group-append
        ></template>
        <template v-slot:content-dropdown>
          <b-dropdown-item @click="createUser()">
            <span>Create New Customer</span>
          </b-dropdown-item>
          <template
            v-if="$store.state.permission.Permission.response.includes(76)"
            ><b-dropdown-item @click="$router.push('/customer/importdata')">
              <span>Import Customer Data (.xlsx) </span>
            </b-dropdown-item>
            <b-dropdown-item @click="$router.push('/customer/importpoint')">
              <span>Import Adjust Point (.xlsx) </span>
            </b-dropdown-item>
            <b-dropdown-item @click="$router.push('/customer/configdata')">
              <span>Import Config</span>
            </b-dropdown-item>
            <b-dropdown-item @click="exportModal()">
              <span>Export Customer</span>
            </b-dropdown-item>

            <b-dropdown-item @click="exportModal(1)">
              <span>Export Billing</span>
            </b-dropdown-item>
            <b-dropdown-item @click="exportModal(2)">
              <span>Export Shipping</span>
            </b-dropdown-item>
            <b-dropdown-item @click="exportModal(3)">
              <span>Export Contact</span>
            </b-dropdown-item>

            <b-dropdown-item @click="downloadPointTemplate">
              <span>Download Adjust Point Template</span>
            </b-dropdown-item></template
          >
        </template>
      </HeaderPanel>
      <div class="bg-white border-red p-2 p-lg-3 mt-3">
        <TableListReportCustomer
          :fields="fields"
          :items="items"
          :isBusy="isBusy"
          :showing="showing"
          :showingTo="showingTo"
          :rows="rows"
          :pageOptions="pageOptions"
          :filter="filter"
          @page="filterPage"
          @createUser="createUser()"
          @handleChangeTake="handleChangeTake"
        />
      </div>
    </div>
    <SidebarFilterReportPanel
      ref="sidebarFilter"
      :filter="filter"
      placeholder="Search Name, Telephone, Email"
      :isConsentList="isConsentList"
      :memberLevelList="memberLevelList"
      :branchList="branchList"
      :birthMonth="birthMonth"
      :AgeGroupFilter="AgeGroupFilter"
      @searchAll="searchAll"
      @clearFilter="clearFilter"
    />
    <ModalInputEmail
      ref="ModalInputEmail"
      :form="filterExportFile"
      @changeEmail="(val) => (filterExportFile.email = val)"
      @submit="getFilterExport"
    />
    <ModalLoading ref="LoadingModal" /> <CreateNewUser notShow ref="newUser" />
  </div>
</template>

<script>
import ModalInputEmail from "@/components/customer/ModalInputEmail";
import OtherLoading from "@/components/loading/OtherLoading";
import ModalLoading from "@/components/modal/ModalLoading";
import CreateNewUser from "@/components/SideBarCreateCustomer/CreateNewUser";
import SidebarFilterReportPanel from "@/components/report/header/SidebarFilterReportPanel";
import TableListReportCustomer from "@/components/report/customer/TableListReportCustomer";
export default {
  components: {
    OtherLoading,
    CreateNewUser,
    SidebarFilterReportPanel,
    TableListReportCustomer,
    ModalLoading,
    ModalInputEmail,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "first_name_th",
          label: "Customer Name",
          class: "text-left",
        },
        {
          key: "member_level_name",
          label: "Tier",
        },
        // {
        //   key: "is_company",
        //   label: "Type",
        // },
        {
          key: "telephone",
          label: "Telephone",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "point_total",
          label: "Point",
        },
        {
          key: "register_date",
          label: "Register Date",
        },
        {
          key: "grand_total",
          label: "Grand Total",
        },
        {
          key: "is_consent",
          label: "Consent Status",
        },
        {
          key: "action",
          label: "",
        },
      ],
      items: [],
      isBusy: true,
      rows: 0,
      showing: 1,
      showingTo: 10,
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      filter: {
        member_level_id: null,
        search: null,
        page: 1,
        take: 10,
        birth_month: null,
        purchase_branch: null,
        is_consent: null,
        AgeGroupFilter: [],
        search_member_id: "",
      },
      AgeGroupFilter: [],
      isConsentList: [
        { id: 1, name: "Yes" },
        { id: 2, name: "Wating For Approve" },
        { id: 0, name: "No" },
        { id: 3, name: "Fail Consent 1" },
        { id: 4, name: "Fail Consent 2" },
        { id: 5, name: "Fail Consent 3" },
        { id: 6, name: "Relieve" },
        { id: 7, name: "Suspend" },
      ],
      birthMonth: [],
      branchList: [],
      memberLevelList: [],
      ageGroup: [],
      filterExportFile: {
        member_level_id: null,
        search: null,
        is_consent: null,
        email: "",
        purchase_branch: null,
        birth_month: null,
      },
    };
  },
  async created() {
    this.getFilter();
    if (this.$route.params.id) this.filter.search = this.$route.params.id;
    await this.getReportCustomer();
    await this.getMemberLevelList();
    let i = 1;
    for (const month of this.$moment.months()) {
      this.birthMonth.push({ text: month, value: i });
      i++;
    }
  },
  methods: {
    sidebarFilter() {
      this.$refs.sidebarFilter.show();
    },
    async getFilter() {
      const result = await this.axios(`/transactioncode/branch`);
      let branchList = [];
      for (const branch of result.data.detail) {
        branchList.push({
          text: `[${branch.plant_id}] ${branch.name} `,
          value: branch.id,
        });
      }
      this.branchList = branchList;
      const ageGroup = await this.axios(
        `/RevenueReport/CustomFilter/age_group`
      );

      this.AgeGroupFilter = ageGroup.data;
    },
    clearFilter() {
      this.filter = {
        member_level_id: null,
        search: null,
        page: 1,
        take: 10,
        birth_month: null,
        purchase_branch: null,
        is_consent: null,
        AgeGroupFilter: [],
        search_member_id: "",
      };
    },
    async getReportCustomer() {
      this.isBusy = true;
      let payload = { ...this.filter };

      for (const [keys, value] of Object.entries(this.filter)) {
        if (keys == "AgeGroupFilter" && payload[keys]) {
          payload[keys] = value.map((el) => el.id);
        }
      }
      // this.getData();
      payload.purchase_branch = payload.purchase_branch
        ? payload.purchase_branch.map((el) => el.value)
        : null;
      payload.birth_month = payload.birth_month
        ? payload.birth_month.map((el) => el.value)
        : null;
      payload.search = payload.search ? payload.search.trim() : "";
      await this.$store.dispatch("getReportCustomerList", payload);
      const data = this.$store.state.report.reportCustomerList;
      this.items = data.detail;
      this.rows = data.total_count;
      this.isBusy = false;
    },
    async getMemberLevelList() {
      await this.$store.dispatch("getMemberLevel");
      let data = this.$store.state.automation.memberLevel;
      if (data.result == 1) {
        this.memberLevelList = data.detail;
      }
    },
    getFilterExport(type) {
      let payload = { ...this.filter };
      payload.purchase_branch = payload.purchase_branch
        ? payload.purchase_branch.map((el) => el.value)
        : null;
      payload.birth_month = payload.birth_month
        ? payload.birth_month.map((el) => el.value)
        : null;

      payload.AgeGroupFilter = payload.AgeGroupFilter
        ? payload.AgeGroupFilter.map((el) => el.value)
        : null;

      this.filterExportFile.member_level_id = this.filter.member_level_id;
      this.filterExportFile.search = this.filter.search;
      this.filterExportFile.is_consent = this.filter.is_consent;
      this.filterExportFile.purchase_branch = payload.purchase_branch;
      this.filterExportFile.birth_month = payload.birth_month;
      this.filterExportFile.AgeGroupFilter = payload.AgeGroupFilter;
      if (type) this.exportReportAddress(type);
      else this.exportReportCustomer();
    },
    async exportReportCustomer() {
      this.$refs.LoadingModal.show();
      await this.$store.dispatch(
        "exportReportCustomerList",
        this.filterExportFile
      );
      const data = this.$store.state.report.respExportCustomer;
      if (data.status == 200) {
        this.confirmAlert({
          message: "Do you want to download the file now?",
          title: "Success !",
          icon: "success",
          confirmButtonText: "Go To Page",
          cancelButtonText: "Close",
        }).then((val) => {
          if (val.isConfirmed) {
            // this.deleteItem(id);
            const routeData = this.$router.resolve({
              name: "Customer Report List",
            });
            window.open(routeData.href, "_blank");
          }
        });
      } else {
        this.errorAlert(data.message);
      }
      this.$refs.LoadingModal.hide();
    },
    async exportReportAddress(type) {
      this.$refs.LoadingModal.show();
      var data = null;
      if (type == 1) {
        data = await this.$report.post(
          "customer/export_customer_billing_list",
          this.filterExportFile
        );
      } else if (type == 2) {
        data = await this.$report.post(
          "customer/export_customer_shipping_list",
          this.filterExportFile
        );
      } else if (type == 3) {
        data = await this.$report.post(
          "customer/export_customer_contact_list",
          this.filterExportFile
        );
      }
      if (data.status == 200) {
        this.confirmAlert({
          message: "Do you want to download the file now?",
          title: "Success !",
          icon: "success",
          confirmButtonText: "Go To Page",
          cancelButtonText: "Close",
        }).then((val) => {
          if (val.isConfirmed) {
            // this.deleteItem(id);
            const routeData = this.$router.resolve({
              name: "Customer Report List",
            });
            window.open(routeData.href, "_blank");
          }
        });
      } else {
        this.errorAlert(data.message);
      }
      this.$refs.LoadingModal.hide();
    },
    filterPage(filter) {
      this.filter = filter;
      this.getReportCustomer();
    },
    handleSearch(filter = this.filter) {
      filter.page = 1;
      this.filter = filter;
      this.getReportCustomer();
    },
    searchAll(filter) {
      this.filter = filter;

      this.getReportCustomer();
    },
    handleChangeTake(filter) {
      this.filter = filter;
      this.getReportCustomer();
    },
    exportModal(type) {
      this.getFilterExport(type);
    },
    async downLoadTemplate(type) {
      this.isLoading = true;
      var data = null,
        filename = "Customer-Template";
      if (type == 1) {
        await this.$store.dispatch("downloadTemplateCustomer");
        data = this.$store.state.importFile.downloadCustomer;
      } else if (type == 2) {
        const res = await this.axios("/Import/getcustomertemplate/billing", {
          responseType: "blob",
        });
        data = res.data;
        filename = "billing-Template";
      } else if (type == 3) {
        const res = await this.axios("/Import/getcustomertemplate/shipping", {
          responseType: "blob",
        });
        data = res.data;
        filename = "shipping-Template";
      } else if (type == 4) {
        const res = await this.axios("/Import/getcustomertemplate/contact", {
          responseType: "blob",
        });
        data = res.data;
        filename = "contact-Template";
      }
      var fileURL = window.URL.createObjectURL(new Blob([data]));
      var fileLink = document.createElement("a");
      var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
      this.isLoading = false;
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${filename}-List-` + dateExcel + `.xlsx`
      );
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async downloadPointTemplate() {
      this.$bus.$emit("showLoading");

      let data = await this.axios(`/import/adjustPointTemplate`, {
        responseType: "blob",
      });
      if (data.status == 200) {
        var fileURL = window.URL.createObjectURL(new Blob([data.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `customer-adjust-point-template.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      } else {
        this.errorAlert("Export Fails");
      }

      this.$bus.$emit("hideLoading");
    },
    createUser() {
      this.$refs.newUser.createUser();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-td-checkbox {
  width: 5%;
}
</style>
